import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

// 解決 ElementUI 導航欄，在 vue-router 3.0 版本以上重複點菜單報錯問題
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    redirect: { name: 'Home' },
  },
  {
    path: '/index',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/qrCode/scan',
    name: 'QrCodeScan',
    component: () => import('@/views/qrCode/Scan.vue'),
  },
  {
    path: '/qrCode/StationScan',
    name: 'QrCodeStationScan',
    component: () => import('@/views/qrCode/StationScan.vue'),
  },
  {
    path: '/qrCode/redirectUri',
    name: 'QrCodeRedirectUri',
    component: () => import('@/views/qrCode/RedirectUri.vue'),
    beforeEnter: (to, from, next) => {
      store.commit('set', { name: 'companyId', value: to.query.companyId });
      // redirectUrl 任一不存在跳轉至錯誤頁
      if (!to.query.redirectUri) {
        next({ name: 'Error' });
        return;
      }
      next();
    },
  },
  {
    path: '/qrCode/ssoCallback',
    name: 'QrCodeSSOCallback',
    component: () => import('@/views/qrCode/SSOCallback.vue'),
    beforeEnter: (to, from, next) => {
      const {
        companyId, memberSourceId, unionId, code,
      } = to.query;
      // 公司代碼、來源代碼、QR Code 行銷活動聯合碼、SSO code 任一不存在，導去錯誤頁
      if (!companyId || !memberSourceId || !unionId || !code) {
        next({ name: 'Error' });
        return;
      }
      next();
    },
  },
  {
    path: '/qrCode/lineLoginCallback',
    name: 'LineLoginCallback',
    component: () => import('@/views/qrCode/LineLoginCallback.vue'),
    beforeEnter: (to, from, next) => {
      const {
        companyId, unionId, code,
      } = to.query;
      // 公司代碼、QR Code 行銷活動聯合碼、SSO code 任一不存在，導去錯誤頁
      if (!companyId || !unionId || !code) {
        next({ name: 'Error' });
        return;
      }
      next();
    },
  },
  {
    path: '/qrCode/blank',
    name: 'Blank',
    props: true,
    component: () => import('@/components/BlankPage.vue'),
  },
  {
    path: '/richMenu/redirectUri',
    name: 'RichMenuRedirectUri',
    component: () => import('@/views/richMenu/RedirectUri.vue'),
  },
  {
    path: '/richMenu/lineLoginCallback',
    name: 'RichMenuLineLoginCallback',
    component: () => import('@/views/richMenu/LineLoginCallback.vue'),
    beforeEnter: (to, from, next) => {
      const {
        companyId, redirectUri, code,
      } = to.query;
      // 公司代碼、導頁網址、LineLogin code 任一不存在，導去錯誤頁
      if (!companyId || !redirectUri || !code) {
        next({ name: 'Error' });
        return;
      }
      next();
    },
  },
  {
    path: '/Error',
    name: 'Error',
    props: true,
    component: () => import('@/components/ErrorPage.vue'),
  },
  {
    path: '/McsQrcodeGetCoupon',
    name: 'McsQrcodeGetCoupon',
    component: () => import('@/components/mcs/McsQrcodeGetCoupon.vue'),
    beforeEnter: (to, from, next) => {
      const {
        companyId, unionId,
      } = to.query;
      // 公司代碼、QR Code 行銷活動聯合碼 任一不存在，導去錯誤頁
      if (!companyId || !unionId) {
        next({ name: 'Error' });
        return;
      }
      next();
    },
  },
  {
    path: '/McfGetPointComplete',
    name: 'McfGetPointComplete',
    props: true,
    component: () => import('@/components/Mcf/McfGetPointCompleteMobile.vue'),
    beforeEnter: (to, from, next) => {
      if (from.name !== 'McsQrcodeGetCoupon') {
        next({ name: 'Error' });
        return;
      }
      next();
    },
  },
  {
    path: '/AddingLineFriend',
    name: 'AddingLineFriend',
    props: true,
    component: () => import('@/components/AddingLineFriend.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: JSON.parse(process.env.VUE_APP_USE_ENV) ? '${VUE_APP_PUBLIC_PATH}' : process.env.VUE_APP_PUBLIC_PATH,
  routes,
});

export default router;
